export function getDefaultLang(): 'es' | 'en' | 'pt' {
  const lang = navigator.language.slice(0, 2)
  if (lang === 'es' || lang === 'en' || lang === 'pt') {
    return lang
  }
  return 'es'
}